<template>
  <div class="home-page">
    <van-nav-bar title="请选择您所在的地区" />
    <div class="container">
      <div class="grid">
        <div class="gridBox" v-for="item in list" :key="item.id" @click="handleGo(item)">
          <van-image :src="item.src"/>
        </div>
      </div>
    </div>
    <div class="history">
      <h2 class="title">我的意见建议</h2>
      <div class="card-bar" v-for="(item, index) in historylist" :key="item.id" @click="goDetail(item)">
        <div class="card-title">
          <span>{{ item.lxsj }}</span>
          <van-tag class="tag-bar" round :color="item.tagColor">{{ item.stateName }}</van-tag>
        </div>
        <div class="card-content">
          <h3 :class="!allShow[index]?'van-multi-ellipsis--l3':''">{{ item.yjnr }}</h3>
          <p @click="onAllShow(index)">{{ allShow[index]?'收缩':'展开' }}</p>
        </div>
      </div>
      <div v-if="historylist.length === 0" class="card-bar">
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/api/getLLZ.js'
import UserInof from '@/api/login'
export default {
  name: 'home',
  data () {
    return {
      cascaderValue: '',
      value: '',
      listImages: [
        { id: '330602', name: '越城区', src: require('../../assets/images/yuCity.png') },
        { id: '330603', name: '柯桥区', src: require('../../assets/images/keCity.png') },
        { id: '330682', name: '上虞区', src: require('../../assets/images/SyCity.png') },
        { id: '330624', name: '新昌县', src: require('../../assets/images/newCity.png') },
        { id: '330681', name: '诸暨市', src: require('../../assets/images/zCity.png') },
        { id: '330683', name: '嵊州市', src: require('../../assets/images/cCity.png') }
      ],
      list: [],
      fieldNames: {
        text: 'name',
        value: 'key',
        children: 'children'
      },
      historylist: [],
      code: '',
      allShow: [],
      textView: '展开'
    }
  },
  async mounted () {
    // const vConsole = new VConsole();
    // 获取当前时间和登录时间
    const nowTime = new Date().getTime()
    const loginTime = localStorage.getItem('loginTime')
    // 登录时间不存在或者超过1个小时，清空登录缓存
    if (loginTime === null || loginTime === undefined || nowTime - loginTime * 1000 / 1000 > 60 * 60 * 1000) {
      localStorage.setItem('username', '')
    }
    // 获取缓存的绑定的用户姓名
    const username = localStorage.getItem('username')
    // 已绑定的情况直接访问历史留言
    if (username !== '' && username != null) {
      this.$toast.success('欢迎\n ' + username + '进入')
      this.getHistory(localStorage.getItem('openid'))
    } else {
      this.GetOpenid()
    }
    this.fetchTreeData()
  },
  methods: {
    onAllShow (index) {
      const tempB = this.allShow[index]
      this.allShow[index] = !tempB
      this.allShow = [...this.allShow]
    },
    async getInfo (code) {
      try {
        const res = await UserInof.GetTrueOpenid(code)
        if (res.username) {
          this.$toast.success('欢迎\n ' + res.username + '进入')
          localStorage.setItem('openid', res.openid)
          localStorage.setItem('username', res.username)
          localStorage.setItem('loginTime', new Date().getTime().toString())
          this.getHistory(res.openid)
        } else {
          this.$toast.fail('首次访问系统，请先绑定用户信息！')
          localStorage.setItem('username', '')
          localStorage.setItem('openid', res.openid)
          this.$router.push({
            path: '/login'
          })
        }
      } catch (error) {
        this.$toast.fail('首次访问系统，请先绑定用户信息！')
        this.$router.push({
          path: '/login'

        })
      }
    },
    // 获取openid
    // 获取第一次code
    GetOpenid () {
      const code = this.getUrlParam('code')
      this.getInfo(code)
    },
    getUrlParam (code) {
      var reg = new RegExp('(^|&)' + code + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r !== null) return unescape(r[2])
      return null
    },
    goDetail (val) {
      this.$router.push({
        path: '/hisdetail',
        query: {
          id: val.id
        }
      })
    },
    handleGo (item) {
      this.$router.push({
        path: '/district',
        query: {
          name: item.name,
          code: item.id
        }
      })
    },
    fetchTreeData () {
      request
        .Tree()
        .then((res) => {
          this.list = res
          this.list.forEach(item => {
            const { name = '' } = item
            const image = this.listImages.find(f => f.name === name)
            if (image) item.src = image.src
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    onFinish ({ selectedOptions }) {
      this.value = selectedOptions.map((option) => option.name).join('-')
      sessionStorage.setItem('Tree', this.cascaderValue)
      sessionStorage.setItem('Treevalue', this.value)
    },
    // 获取历史留言
    async getHistory (openid) {
      const res = await request.getHistory(openid)
      this.historylist = res.list
      this.allShow = this.historylist.map(() => false)
      this.historylist.forEach(item => {
        item.tagColor = 'rgba(240, 163, 49, 1)'
        item.stateName = '未回复'
        if (item.llzdfnr || item.dbdfnr || item.sptdfnr) {
          item.tagColor = 'rgba(103, 194, 57, 1)'
          item.stateName = '已回复'
        }
      })
    }

  }

}
</script>
<style lang="less" scoped>
.home-page{
  .container {
    position: relative;
    .submitBtn {
      position: absolute;
      top: 25px;
      right: 15px;
    }
  }
  .history {
    border-top: 1px solid #ccc;
    background-color: rgba(140, 140, 140, 0.1);
    padding: 25px;
    .card-bar{
      padding: 25px;
      background-color: #fff;
      margin-bottom: 25px;
      border-radius: 10px;
      box-shadow: 0px 2px 4px 1px #F2F3F5;
      .card-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid rgba(140, 140, 140, 0.3);
        padding-bottom: 25px;
        span{
          font-size: 28px;
          font-weight: 300;
          color: #A0A0A0;
        }
        .tag-bar{
          padding: 10px 25px;
          color: #fff;
        }
      }
      .card-content{
        font-size: 28px;
        h3{
          text-align: justify;
        }
        p{
          text-align: end;
          color: rgba(7, 193, 96, 0.7);
        }
      }
    }
    .card-bar:last-child{
      margin-bottom: 0;
    }
    .title {
      font-size: 35px;
    }
    .noMessage {
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 30px;
      color: #ccc;
    }
  }
}

/deep/.van-cascader__title {
  font-size: 30px;
}
/deep/ .van-cascader__options {
  height: 140vw;
}
.grid {
  margin: 10px 0 0 0;
}
.state {
  width: 100px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  background-color: #e6a23c;
  margin: 25px 5px 0 0;
  border-radius: 15px;
}
.grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 10px;
}
.gridBox {
  width: 30%;
  height: 268px;
}
// .ke {
//   background: url('../../assets/images/keCity.png') no-repeat center;
// }
</style>
